import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class MonitoringService {
  private readonly baseUrl = `${environment.api_base_url}`;
  private readonly apiUrl = `${environment.api_base_url}errors`;

  constructor(private readonly http: HttpClient) {}

  /**
   * GET api/errors
   */
  getErrors(
    filters?: Record<string, string | number | boolean | null | undefined>
  ): Observable<any> {
    const params = this.createHttpParams(filters);

    return this.http.get<any>(this.apiUrl, { params });
  }

  /**
   * GET api/errors/dashboard
   */
  getErrorsDashboard(
    filters?: Record<string, string | number | boolean | null | undefined>
  ): Observable<any> {
    const params = this.createHttpParams(filters);

    return this.http.get<any>(
      `${this.apiUrl}/dashboard`,
      { params }
    );
  }

  /**
   * GET api/errors/{id}
   */
  getErrorById(id: string | number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${encodeURIComponent(String(id))}`
    );
  }

  /**
   * POST api/errors/{id}/resolve
   */
  resolveError(
    id: string | number,
    body: any = {}
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${encodeURIComponent(String(id))}/resolve`,
      body
    );
  }

  /**
   * POST api/errors/{id}/reopen
   */
  reopenError(
    id: string | number,
    body: any = {}
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/${encodeURIComponent(String(id))}/reopen`,
      body
    );
  }

  /**
   * POST api/errors/{error_id}/notes
   */
  addErrorNote(
    errorId: string | number,
    note: string
  ): Observable<any> {
    const body: any = { note };

    return this.http.post<any>(
      `${this.apiUrl}/${encodeURIComponent(String(errorId))}/notes`,
      body
    );
  }

  private createHttpParams(
    values?: Record<string, string | number | boolean | null | undefined>
  ): HttpParams {
    let params = new HttpParams();

    if (!values) {
      return params;
    }

    Object.keys(values).forEach((key) => {
      const value = values[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return params;
  }
  
  infinte(url) {
    return this.http.get<any>(
      `${url}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/service/monitoring.service.ts